import { analytics } from 'Modules/Analytics'
import { upgrade } from 'Modules/Analytics/trackActionInterface/Account/upgrade'
import { useAppDispatch } from 'Context/AppContext/AppContext'
import { DialogVariant, UPDATE_GLOBAL_DIALOG } from 'TypeDefs/AppContext'

export const useShowUpgradeModalDialog = () => {
  const dispatch = useAppDispatch()
  const showUpgradeModalDialog = (isVisible: boolean) => {
    // These three events might have meant different things at some point, but not anymore
    analytics.trackActionCreator(upgrade.CTA_Clicked)({})
    analytics.trackActionCreator(upgrade.Button_Clicked)({})
    analytics.trackActionCreator(upgrade.Modal_Viewed)({})

    dispatch({
      type: UPDATE_GLOBAL_DIALOG,
      payload: {
        variant: DialogVariant.UPGRADE_MODAL_DIALOG,
        isVisible,
      },
    })
  }

  return showUpgradeModalDialog
}
